import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { getTickets } from '../../../../ducks/user/user';
import Flash from '../../components/Flash';
import Header from '../../components/Header';
import TicketList from '../../components/TicketList';
import withUser from '../../../../components/withUser';

const propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    checkin_code: PropTypes.string.isRequired,
  })),
  event: PropTypes.shape({
    id: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
  onRequestOpenFn: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  user: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
  error: PropTypes.oneOfType([
    PropTypes.shape({
      response: PropTypes.shape({}),
    }),
    PropTypes.bool,
  ]),
  ticketsError: PropTypes.oneOfType([
    PropTypes.shape({
      response: PropTypes.shape({}),
    }),
    PropTypes.bool,
  ]),
  history: PropTypes.shape({
    stackPush: PropTypes.func.isRequired,
  }).isRequired,
};

class Ticket extends React.Component {
  componentDidMount() {
    const { dispatch, user } = this.props;
    if (user) {
      dispatch(getTickets());
    }
  }

  render() {
    const {
      error,
      event,
      history,
      loading,
      onRequestOpenFn,
      tickets,
      ticketsError,
      user,
    } = this.props;

    return (
      <>
        <Header
          onMenuOpen={onRequestOpenFn}
          history={history}
          showUser
        >
          My tickets
        </Header>
        <Flash
          title="Whoops!"
          message={ticketsError}
          error
        />
        <TicketList
          tickets={tickets}
          loading={loading}
          event={event}
          user={user}
          error={error}
          onReload={() => this.getTickets()}
        />
      </>
    );
  }
}

Ticket.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.getIn(['event', 'loading']) || state.getIn(['user', 'loading']),
    error: state.getIn(['event', 'error']),
    event: state.getIn(['event', 'data']),
    tickets: state.getIn(['user', 'tickets']),
    ticketsError: state.getIn(['user', 'tickets_error']),
  };
}

export default withUser(connect(mapStateToProps)(Ticket));
